import axios from "axios";
import { getAuthToken } from "../util/auth";
import API_BASE_URL from "../util/apiConfig";

const token = getAuthToken();

const settingsClient = axios.create({
  baseURL: `${API_BASE_URL}/settings`,
  headers: {
    Authorization: "Bearer " + token,
  },
});

settingsClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error.response.data);
  }
);

export async function getUserSettings({ signal }) {
  const response = await settingsClient.get("", { signal });
  return response.data;
}

export async function setUserSettings({ userSettings }) {
  const response = await settingsClient.post("", userSettings);
  return response.data;
}
